// extracted by mini-css-extract-plugin
export default {"disabled":"FeatureButton_disabled__DrZnd"};